module.exports = require("@arco-design/web-react");